// extracted by mini-css-extract-plugin
export default {"otp_input_container_container":"otp-input-container_otp_input_container_container__z1J4G"};